import React from 'react';
import { render } from 'react-dom';
import configureStore, { history } from './store/configureStore';
import Root from './components/Root';
import * as serviceWorker from './serviceWorker';

const originalFetch = window.fetch;
window.fetch = async (...args) => {
    const response = await originalFetch(...args);
    if (response.status === 401) {
        const rememberme = localStorage.getItem('myapp-rememberme');
        const email = localStorage.getItem('myapp-email');
        const password = localStorage.getItem('myapp-password');
        localStorage.clear();
        if (rememberme === 'true') {
            localStorage.setItem('myapp-rememberme', rememberme);
            localStorage.setItem('myapp-email', email);
            localStorage.setItem('myapp-password', password);
        }
        window.location.href = '/#/login';
        return new Promise(() => {});
    }
    return response;
};

const store = configureStore();

render(
  <Root store={store} history={history} />,
  document.getElementById('root')
);


// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
